/** @format */

export interface iLoader {
    show: boolean;
}

export const LoaderInitialData: iLoader = Object.freeze({
    show: true,
});
